import { render, staticRenderFns } from "./businessUnitIndex.vue?vue&type=template&id=40a2441c&"
import script from "./businessUnitIndex.vue?vue&type=script&lang=js&"
export * from "./businessUnitIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports